import { render, staticRenderFns } from "./welcome-panel.vue?vue&type=template&id=5c9814d6"
import script from "./welcome-panel.vue?vue&type=script&lang=js"
export * from "./welcome-panel.vue?vue&type=script&lang=js"
import style0 from "./welcome-panel.vue?vue&type=style&index=0&id=5c9814d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports